import { useState } from "react";

import { usePortalNode } from "../hooks";

interface DialogHook {
  (props: { visible: boolean }): {
    isHidden: boolean;
    portalNode: HTMLElement | null;
    setIsHidden: (isHidden: boolean) => void;
  };
}

export const useDialog: DialogHook = ({ visible }) => {
  const portalNode = usePortalNode();
  const [isHidden, setIsHidden] = useState(!visible);

  return { isHidden, portalNode, setIsHidden };
};
